<template>
  <a-modal
    :visible="visible"
    title="下载文件"
    okText="下载"
    @ok="handleOk"
    @cancel="handleCancel"
  >
    <div class="m-4">
        <a-alert class="my-4" message="下载成功" type="success" v-if="percent === 100" />
        <a-progress class="mb-4" v-if="isProgress" :percent="percent" />
        <a-checkbox-group v-model="downloadType" :options="checkOptions" />
    </div>
  </a-modal>
</template>

<script>
import { mapGetters } from 'vuex';
import { downloadUrl } from '@/utils/download';
import { Progress } from 'ant-design-vue';
import { merge } from 'lodash';

export default {
  props: {
    visible: Boolean,
    queryparams: Object,
    cateid: Number
  },
  components: {
    AProgress: Progress,
  },
  data() {
    return {
      checkOptions: [
        // {
        //   label: '保函文件',
        //   value: 1,
        // },
        {
          label: '发票文件',
          value: 2,
        },
      ],
      src: [],
      downloadType: [],
      ws: null,
      isProgress: false,
      percent: 0,
    };
  },
  computed: {
    ...mapGetters({
        userInfo: 'userInfo',
    }),
  },
  watch: {
    percent(a) {
      if (a === 100) {
        if (this.src.length > 0) {
          if (this.ws) {
            this.ws.close();
          }
          this.src.forEach(url => {
            let file = url.split('/');
            downloadUrl(this.$ossUrl + '/' + url, file[file.length - 1]);
          });
          this.$message.success('下载完成');
        }
      }
    }
  },
  methods: {
    handleOk() {
      this.isProgress = true;
      this.$emit('downloadStart');
      this.queryparams = merge(this.queryparams, { custom: { isRecommended: '1' } });
      const wsUrl = process.env.NODE_ENV === 'development' 
        ? 'ws://localhost:9091/api/v1/contract_download_connect' 
        : 'wss://yl.jdbsk.com/api/v1/contract_download_connect';
      this.ws = new WebSocket(wsUrl);
      this.ws.onopen = () => {
        this.ws.send(
          JSON.stringify({
            ids: this.downloadType.join(),
            uid: this.userInfo.id || '',
            cate_id: this.cateid,
            qps: JSON.stringify(this.queryparams)
          })
        );
      };
      
      this.ws.onmessage = (res) => {
        const data = JSON.parse(res.data);
        this.percent = data.percent;
        this.src = data.src;
      };
      
      this.ws.onclose = () => {
        this.ws = null;
        this.isProgress = false;
        this.$emit('ok');
        this.$emit('cancel');
        this.percent = 0;
        this.$emit('downloadComplete');
      };
      
      this.ws.onerror = (err) => {
        this.isProgress = false;
        this.$message.error('下载失败，请重试');
      };
    },
    handleCancel() {
      if (this.ws) {
        this.ws.close();
        this.ws = null;
      }
      this.$emit('cancel');
    }
  },
  beforeDestroy() {
    if (this.ws) {
      this.ws.close();
      this.ws = null;
    }
  }
};
</script>